var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76730b542b6185b45079cd497cca5f8d.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c74f70d2ba4b45ef7fb1b60273a073f6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    